import { Component, ComponentChild, createContext } from 'preact';

declare global {
  interface Window {
    fastdom: Fastdom;
    fastdomPromised: FastDomPromised;
  }
}

const dom = window.fastdom.extend(window.fastdomPromised);
dom.initialize();

export interface FastDomContext {
  dom: typeof dom;
}

export const FastDomContext = createContext<FastDomContext>({ dom });

export class FastDomProvider extends Component {
  // eslint-disable-next-line class-methods-use-this
  getChildContext(): FastDomContext {
    return {
      dom,
    };
  }

  render(): ComponentChild {
    return <FastDomContext.Provider value={this.getChildContext()}>{this.props.children}</FastDomContext.Provider>;
  }
}
